import { Component } from '@angular/core';

@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts